<template lang="pug">
	.publisher-contacts
		.page-center-content
			.caption-area Customer contacts
			.publishers-table
				DataTable(entity="publisher_contacts" :fields="fields" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:publisher-contacts']" focus-on="Layout Page Showed:publisher-contacts" :height-offset="Layout.headerHeight + 45")

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Layout } 			from './../../services/Layout'
	import { Publisher } 		from './../../services/Publisher'
	import { User } 			from './../../services/User'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "PublisherContacts",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Publisher Changed", "Layout Page Showed:publisher-contacts"]
		},
		components: {
			DataTable
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: true,
					click: this.publisherContactClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '70px'
				},
				{
					fieldName: 'name',
					title: 'Name',
					type: 'string',
					display: true,
					click: this.publisherContactClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '100px',
					displayStyles: () => {return {display: 'block', width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'email',
					title: 'Email',
					type: 'string',
					display: true,
					click: this.publisherEmailClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '150px',
					displayStyles: () => {return {display: 'block', width: '150px', height: '80px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'message',
					title: 'Message',
					type: 'string',
					display: true,
					click: this.publisherContactClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '250px',
					displayStyles: () => {return {display: 'block', width: '250px', height: '80px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'source',
					title: 'Source',
					type: 'string',
					display: true,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '100px',
					displayStyles: () => {return {display: 'block', width: '100px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'gclid',
					title: 'Google Ads',
					type: 'boolean',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '90px'
				},
				{
					fieldName: 'date',
					title: 'Contact date',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '100px'
				},
				{
					fieldName: 'ga_event',
					title: 'Conversion',
					type: 'boolean',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '90px'
				},
				{
					fieldName: 'active',
					title: 'Active',
					type: 'boolean',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					editAllowed: true,
					onChange: this.togglePublisherContactStatus,
					width: '90px'
				}
			];

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

			},
			togglePublisherContactStatus(publisherContact) {

				Server.sendToSocket({
					SetPublisherContactStatus: {
						publisherContactId: publisherContact.id,
						active: publisherContact.active
					}
				})

			},
			publisherContactClick(publisherContact) {

				Broadcast.call('Show Confirm', [{
					caption: 'Publisher Contact',
					message: publisherContact.message,
					confirmButtonText: 'OK',
					confirmButtonIcon: 'fa-ok',
					height: 'auto',
					confirmCallback: () => {

					}
				}]);

			},
			publisherEmailClick(publisherContact) {

				Broadcast.call('Show Confirm', [{
					caption: 'Publisher Contact E-mail',
					message: publisherContact.email,
					confirmButtonText: 'OK',
					confirmButtonIcon: 'fa-ok',
					height: 'auto',
					confirmCallback: () => {

					}
				}]);

			}
		}
	}
</script>

<style lang="sass" scoped>

	.publisher-contacts
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1100px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)
				padding: 0.7rem 1rem

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

</style>

